export default {
    label_task:{
        en:"Research Picture Type",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Research Picture",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Research Picture",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Research Picture",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}